import $ from 'jquery';

import Section from "../Section";
import MobileMenu from '../global/MobileMenu';
import Menu from '../global/Menu';
import { CART_UPDATE_EVENT } from '../ThemeBase';
import { initiateFadeInUpAnimation, removeFadeInUpAnimation } from '../global/fadeInUpAnimation';

export default class Header extends Section {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.$element = $(this.element);

    Array.prototype.forEach.call(
      this.element.querySelectorAll('.js-drawer-open-right-link'),
      (el) => el.addEventListener('click', this.onCartButtonClick),
    );
    this.element.querySelector('.js-drawer-open-left-link').addEventListener('click', this.onMobileMenuButtonClick)
    this.mobileMenu = new MobileMenu(theme, this.element.querySelector('.drawer--left'));

    document.documentElement.addEventListener(CART_UPDATE_EVENT, this.onCartUpdate);

    if (window.Shopify.designMode) {
      const headerEl = this.element.querySelector('header');
      const overlayHeader = this.element.dataset.headerOverlay;

      document.addEventListener('shopify:inspector:activate', () => {

        // Disable sticky header
        this.element.setAttribute('data-inspector-active', 'true');
        const headerWrapper = this.element.closest('.shopify-section');
        if (this.element.dataset.headerSticky === 'true') headerWrapper.classList.remove('sticky-header');

        // Disable overlay header
        if (overlayHeader == 'true') {
          this.element.classList.remove('overlay-header-wrapper');
          if (headerEl) headerEl.classList.remove('overlay-header');
        }

      });

      document.addEventListener('shopify:inspector:deactivate', () => {

        // Re-enable sticky header
        this.element.setAttribute('data-inspector-active', 'false');
        if (this.element.dataset.headerSticky === 'true') this.loadStickyHeader();

        // Re-enable overlay header
        if (overlayHeader == 'true') {
          this.element.classList.add('overlay-header-wrapper');
          if (headerEl) headerEl.classList.add('overlay-header');
        }

      });
    }

    this.handleStickyHeaderVars();

    // Close mobile menu on overlay click
    this.element.querySelector('#NavDrawerOverlay').addEventListener('click', () => this.theme.toggleLeftDrawer(false));

    this.loadAccessibleMenu();
    if (this.element.dataset.headerSticky === 'true' && (this.element.dataset.inspectorActive == 'false' || !this.element.dataset.inspectorActive)) {
      this.loadStickyHeader();
    }
    this.loadSearchDrawer();
    this.menu = new Menu(this, element);
    this.handleExternalLinks();
  }

  handleStickyHeaderVars = () => {
    const isStickyHeader = this.element.dataset.headerSticky === 'true';
    if (isStickyHeader) {
      this.setStickyHeaderVar('.mobile-nav-bar-wrapper', '--sticky-header-mobile-height');
      this.setStickyHeaderVar('.site-header', '--sticky-header-desktop-height');
    } else {
      this.resetStickyHeaderVar('--sticky-header-mobile-height');
      this.resetStickyHeaderVar('--sticky-header-desktop-height');
    }
  }
  
  setStickyHeaderVar = (selector, varName) => {
    const header = this.element.querySelector(selector);
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty(varName, `${headerHeight}px`);
  }
  
  resetStickyHeaderVar = (varName) => {
    document.documentElement.style.setProperty(varName, `0px`);
  }
  
  onCartUpdate = (e) => {
    Array.prototype.forEach.call(
      document.querySelectorAll('.cart-item-count-header--quantity'),
      (el) => {
        el.classList.add('hide');

        const cartHasItems = e.detail.cart.item_count > 0;
        el.textContent = e.detail.cart.item_count;

        if (cartHasItems) el.classList.remove('hide');
      },
    );
  }

  onCartButtonClick = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('cart');
  }

  onMobileMenuButtonClick = (e) => {
    e.preventDefault();
    this.mobileMenu.toggle();
  }

  loadSearchDrawer = () => {
    document.querySelectorAll('.search-button').forEach(item => {
      item.addEventListener('click', this.onSearch)
    });
  }

  onSearch = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('search', true);
  }

  loadAccessibleMenu = () => {
    this.$element.find('.site-nav').addClass('js');
    this.$element.find('.site-nav li a').focus(function() {
      // main nav anchor focus
      $(this)
        .parent()
        .children('ul')
        .fadeIn();
    });
    this.$element.find('.site-nav li li a').off(); // unbind hide drop downs from sub nav anchors

    const self = this;
    this.$element.find('.mobile-nav__link').on('click', function() {
      const a = /** @type {HTMLAnchorElement} */ (this);
      if (
        a.href &&
        a.href.split('#')[0] === window.location.href.split('#')[0]
      ) {
        // Anchor on same page - just close the drawer
        self.theme.toggleLeftDrawer(false);
      }
    });

    this.tabindexMobileNav();
  };

  tabindexMobileNav = () => {
    // Mobile menu should not be keyboard-navigable while viewing on desktop.
    if(window.innerWidth > 767) {
      this.$element.find('#NavDrawer a, #NavDrawer button').attr('tabindex', -1);
    }
    else {
      this.$element.find('#NavDrawer a:not(.promo-text), #NavDrawer button').removeAttr('tabindex');
    }
  }

  onWindowResize = ({ width, oldWidth, breakpoint }) => {
    this.tabindexMobileNav();
    this.handleStickyHeaderVars();
  }

  // Sticky page header
  loadStickyHeader = () => {

    if ('IntersectionObserver' in window) {
      // We need to apply sticky to child of element that is being scrolled, in
      // this case it's the whole `shopify-section`
      const headerWrapper = this.element.closest('.shopify-section.header-section');
      headerWrapper.classList.add('sticky-header');
  
      const observer = new IntersectionObserver(
        ([e]) => {
          if (e.intersectionRatio < 1) {
            e.target.classList.add('sticked');
            // Dispatch a custom event when the header becomes 'sticked'
            const stickedEvent = new CustomEvent('headerSticked', { detail: e.target });
            document.dispatchEvent(stickedEvent);
          } else {
            e.target.classList.remove('sticked');
            // Dispatch a custom event when the header becomes 'unstuck'
            const unstuckEvent = new CustomEvent('headerUnstuck', { detail: e.target });
            document.dispatchEvent(unstuckEvent);
          }
        },
        {
          threshold: [1],
        },
      );
  
      observer.observe(headerWrapper);
    }
  }  

  onBlockSelect = ({ element }) => {
    // Prevent menu reopening on deselect due to editor event bug where select event is fired on deselect after editing a text input setting
    if (document.body.hasAttribute('data-mega-menu-deselected')) return;

    // Open mega menu and make overlay force-hovered
    if (element.dataset.megaMenuBlockId) {
      this.$element.find('[data-mega-menu-block-id=' + element.dataset.megaMenuBlockId + ']').closest('li.mega-menu').addClass('force-open');
      this.$element.find('.overlay-header').addClass('force-hover');

      const megaMenuChildrenArray = Array.from(this.$element.find('li.mega-menu.force-open .mega-menu-block .dropdown-submenu'));
      initiateFadeInUpAnimation(megaMenuChildrenArray); // Initiate mega menu animation
    }
  }

  onBlockDeselect = () => {
    // Needed to prevent menu reopening on deselect due to editor event bug where select event is fired on deselect after editing a text input setting
    document.body.setAttribute('data-mega-menu-deselected', 'true');
    setTimeout(() => {
      document.body.removeAttribute('data-mega-menu-deselected');
    }, 500);

    // Close mega menu and make overlay non-hovered
    this.$element.find('li.mega-menu.force-open').removeClass('force-open');
    this.$element.find('.overlay-header').removeClass('force-hover');

    const megaMenuChildrenArray = Array.from(this.$element.find('li.mega-menu .mega-menu-block .dropdown-submenu'));
    removeFadeInUpAnimation(megaMenuChildrenArray); // Remove mega menu animation
  }

  handleExternalLinks = () => {
    var links = this.element.querySelectorAll('a');
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  }
}
